// extracted by mini-css-extract-plugin
module.exports = {"title":"PaymentOptions_title__SNxiD","methods":"PaymentOptions_methods__32Saf","option":"PaymentOptions_option___UyXK","active":"PaymentOptions_active__2G0H9"};